export default function FeaturedGrid() {
  return (
    <section className="py-20 md:py-28 bg-background-50 relative overflow-hidden">
      {/* Subtle decorative elements */}
      <div className="absolute top-0 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-background-300/40 to-transparent"></div>
      <div className="absolute bottom-0 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-background-300/40 to-transparent"></div>
      <div className="bg-orb bg-orb-accent w-[300px] h-[300px] -top-[100px] left-[60%] animate-orb-float opacity-50"></div>

      <div className="max-w-[1280px] mx-auto px-4 md:px-6 relative">
        <div className="text-center mb-14">
          <h2 className="font-heading font-bold text-[38px] md:text-[44px] leading-[1.15] text-foreground-950">
            Curated Finds
            <br />
            <span className="text-accent-500">Verified Quality</span>
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-[500px] mx-auto">
            Hand-picked CSSBuy spreadsheet gems — every item verified by our community of trusted reviewers
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-5">
          <div className="w-full lg:w-[50%] h-[400px] md:h-[520px] rounded-3xl overflow-hidden relative group cursor-pointer">
            <img
              src="https://readdy.ai/api/search-image?query=Luxury%20designer%20sneakers%20collection%20displayed%20on%20warm%20cream%20minimal%20background%2C%20soft%20diffused%20studio%20lighting%2C%20editorial%20product%20photography%2C%20warm%20beige%20neutral%20tones%2C%20elegant%20composition%2C%20multiple%20sneakers%20arranged%20artfully%2C%20clean%20aesthetic%2C%20soft%20shadows%2C%20high%20end%20fashion%20presentation%2C%20organic%20textures%2C%20no%20text%2C%20sophisticated%20product%20display%20with%20warm%20lighting&width=800&height=1040&seq=featured-shoes-01&orientation=portrait"
              alt="CSSBuy Spreadsheet Shoes Collection"
              title="CSSBuy Spreadsheet Shoes"
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/60 via-transparent to-transparent"></div>
            <a
              href="https://kaspreadsheet.com/category-911-Shoes.html"
              target="_blank"
              rel="noopener nofollow"
              className="absolute bottom-6 left-6 inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-background-50/90 backdrop-blur-sm text-foreground-900 text-sm font-semibold hover:bg-background-50 transition-colors whitespace-nowrap cursor-pointer"
            >
              Shoes
              <i className="ri-arrow-right-up-line text-base"></i>
            </a>
          </div>

          <div className="w-full lg:w-[50%] flex flex-col gap-5">
            <div className="flex-1 rounded-3xl overflow-hidden relative group cursor-pointer min-h-[200px]">
              <img
                src="https://readdy.ai/api/search-image?query=Premium%20quality%20hoodies%20and%20sweaters%20fashion%20collection%20on%20warm%20sage%20green%20tinted%20background%2C%20soft%20diffused%20studio%20lighting%2C%20editorial%20product%20photography%2C%20warm%20neutral%20tones%20with%20subtle%20green%20hints%2C%20minimalist%20composition%2C%20clean%20aesthetic%2C%20soft%20shadows%2C%20elegant%20casual%20fashion%20presentation%2C%20organic%20textures%2C%20no%20text%2C%20cozy%20lifestyle%20vibe&width=800&height=500&seq=featured-hoodies-02&orientation=landscape"
                alt="CSSBuy Spreadsheet Hoodies Collection"
                title="CSSBuy Spreadsheet Hoodies & Sweaters"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/50 via-transparent to-transparent"></div>
              <a
                href="https://kaspreadsheet.com/search-912/name/Shoes.html"
                target="_blank"
                rel="noopener nofollow"
                className="absolute bottom-5 left-5 inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-background-50/90 backdrop-blur-sm text-foreground-900 text-sm font-semibold hover:bg-background-50 transition-colors whitespace-nowrap cursor-pointer"
              >
                Hoodies/Sweaters
                <i className="ri-arrow-right-up-line text-base"></i>
              </a>
            </div>

            <div className="flex-1 rounded-3xl overflow-hidden relative group cursor-pointer min-h-[200px]">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20fashion%20accessories%20collection%20with%20watches%20belts%20and%20jewelry%20on%20warm%20soft%20pink%20tinted%20background%2C%20soft%20diffused%20studio%20lighting%2C%20editorial%20product%20photography%2C%20warm%20neutral%20tones%20with%20subtle%20rose%20hints%2C%20minimalist%20composition%2C%20clean%20aesthetic%2C%20soft%20shadows%2C%20luxury%20presentation%2C%20organic%20textures%2C%20no%20text%2C%20sophisticated%20lifestyle%20display&width=800&height=500&seq=featured-accessories-03&orientation=landscape"
                alt="CSSBuy Spreadsheet Accessories Collection"
                title="CSSBuy Spreadsheet Accessories"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/50 via-transparent to-transparent"></div>
              <a
                href="https://kaspreadsheet.com/search-920/name/Shoes.html"
                target="_blank"
                rel="noopener nofollow"
                className="absolute bottom-5 left-5 inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-background-50/90 backdrop-blur-sm text-foreground-900 text-sm font-semibold hover:bg-background-50 transition-colors whitespace-nowrap cursor-pointer"
              >
                Accessories
                <i className="ri-arrow-right-up-line text-base"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}